<template>
    <div class="row">
        <div v-if="isSubOrder" class="col-12 mb-0">
            <div class="alert alert-info p-1 d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <feather-icon icon="LayersIcon" size="16" class="mr-50" />
                    <span class="font-small-3">
                        <strong>Ana Sipariş:</strong> {{ value.MainOrderNumber || "Belirtilmemiş" }}
                        <span v-if="subOrderIndex !== null" class="ml-1">| <strong>Parça:</strong> #{{ subOrderIndex + 1 }}</span>
                    </span>
                </div>
                <b-badge v-if="value.OrderQuantity" variant="light-primary" class="font-small-3">
                    {{ value.OrderQuantity.toLocaleString("tr-TR") }} lt
                </b-badge>
            </div>
        </div>

        <div v-if="value.Id && !isSubOrder" class="col-12 mb-0">
            <div class="alert p-1 d-flex justify-content-between" :class="statusVariantClass">
                <div>
                    <feather-icon icon="FileTextIcon" size="16" class="mr-50 mb-25" />
                    <strong class="mr-1">{{ value.OrderNumber }}</strong>
                </div>
                <div>
                    <feather-icon icon="TruckIcon" size="16" class="mr-50 mb-25" />
                    <span>{{ value.OrderStatusName }}</span>
                </div>
            </div>
        </div>

        <div class="col-md-6 mb-1">
            <label class="form-label">Sipariş Yakıt Tipi <span class="text-danger">*</span> </label>
            <v-select-list
                v-model="fuelType"
                :options="fuelTypes"
                label="VisibleName"
                placeholder="Yakıt Tipi Seçin"
                :disabled="isReadOnly"
            ></v-select-list>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Sipariş Tarihi</label>
            <v-date-picker
                v-model="value.OrderDate"
                placeholder="Sipariş Tarihi"
                :disabled="isReadOnly"
                :disabled-date="disableDatesBeforeOneWeekAgo"
            >
            </v-date-picker>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Tedarikçi</label>
            <v-select-list :options="suppliers" v-model="supplier" placeholder="Tedarikçi" label="Name" :disabled="isReadOnly"></v-select-list>
        </div>

        <div class="col-md-6 mb-1">
            <label class="form-label">Ödeme Yöntemi</label>
            <v-select
                v-model="value.PaymentType"
                :options="paymentTypes"
                :reduce="(x) => x.id"
                label="label"
                placeholder="Seçiniz"
                :disabled="isReadOnly"
            />
        </div>
        <div class="col-md-6 mb-1" v-if="value.PaymentType === 1">
            <label class="form-label">Kredi Kartı</label>
            <v-select
                v-model="value.FuelStorageCreditCardInformationId"
                :options="creditCards"
                :reduce="(x) => x.Id"
                label="CreditCardLast4Value"
                placeholder="Kart Seçiniz"
                :disabled="isReadOnly"
            />
        </div>
        <div class="col-md-6 mb-1" v-if="value.PaymentType === 1">
            <label class="form-label">Son Ödeme Tarihi</label>
            <v-date-picker v-model="value.FuelStorageCreditCardLastPaymentDate" disabled placeholder="Otomatik Hesaplanır"></v-date-picker>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Miktar [lt]</label>
            <VCurrencyInput :value="value.OrderQuantity" @update-value="value.OrderQuantity = $event" :disabled="isReadOnly" />
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Birim Fiyat [TL/lt] </label>
            <VCurrencyInput :value="value.UnitPrice" @update-value="value.UnitPrice = $event" :disabled="isReadOnly" />
        </div>
        <div class="col-12 mb-1">
            <div class="price-info-box" :class="`price-info-box--${priceInfo.status}`">
                <!-- Header: Icon + Title + Progress Dots -->
                <div class="price-info-box__header">
                    <div class="price-info-box__icon" :class="`price-info-box__icon--${priceInfo.status}`">
                        <feather-icon :icon="priceInfo.icon || 'HelpCircleIcon'" size="20" />
                    </div>
                    <div class="price-info-box__title-wrapper">
                        <div class="price-info-box__title">{{ priceInfo.title }}</div>
                        <div class="price-info-box__subtitle" v-if="priceInfo.basePrice && priceInfo.step === 5">
                            Rafineri: {{ priceInfo.basePrice.toFixed(2) }} TL/lt
                        </div>
                        <div class="price-info-box__subtitle" v-else-if="priceInfo.subtitle && priceInfo.step === 5">
                            {{ priceInfo.subtitle }}
                        </div>
                    </div>
                    <div class="price-info-box__dots" v-if="priceInfo.step < 5">
                        <span
                            v-for="i in 4"
                            :key="i"
                            class="price-info-box__dot"
                            :class="{
                                'price-info-box__dot--done': i <= priceInfo.step,
                                'price-info-box__dot--current': i === priceInfo.step + 1,
                            }"
                        ></span>
                    </div>
                </div>

                <!-- Body: Wizard - Eksik Alan -->
                <div class="price-info-box__body" v-if="priceInfo.missingFields && priceInfo.missingFields.length > 0">
                    <div class="price-info-box__next-step">
                        <feather-icon icon="ArrowRightIcon" size="14" class="text-primary" />
                        <span
                            >Sonraki adım: <strong>{{ priceInfo.missingFields[0] }}</strong></span
                        >
                    </div>
                </div>

                <!-- Body: Sonuç -->
                <div class="price-info-box__body" v-else-if="priceInfo.step === 5 && priceInfo.currentDeal">
                    <!-- Mevcut Seçim Detayı -->
                    <div class="price-info-box__result" v-if="priceInfo.currentDeal">
                        <div class="price-info-box__result-row">
                            <span>Seçili Ödeme:</span>
                            <strong>{{ priceInfo.currentDeal.label }}</strong>
                        </div>
                        <div class="price-info-box__result-row" v-if="priceInfo.currentDeal.rate > 0">
                            <span>İskonto:</span>
                            <strong class="text-success">%{{ priceInfo.currentDeal.rate }}</strong>
                        </div>
                        <div class="price-info-box__result-row price-info-box__result-row--total">
                            <span>Birim Fiyat lt/TL:</span>
                            <div class="price-info-box__price-compare" v-if="priceInfo.currentDeal.rate > 0 && priceInfo.basePrice">
                                <span class="price-info-box__old-price">{{ priceInfo.basePrice.toFixed(2) }} TL</span>
                                <strong class="text-success">{{ priceInfo.currentDeal.finalPrice.toFixed(2) }} TL</strong>
                            </div>
                            <strong v-else>{{ priceInfo.currentDeal.finalPrice.toFixed(2) }} TL</strong>
                        </div>
                    </div>

                    <!-- Daha İyi Alternatif -->
                    <div
                        class="price-info-box__better-option"
                        v-if="
                            priceInfo.bestDeal &&
                            priceInfo.currentDeal &&
                            priceInfo.bestDeal.paymentType !== value.PaymentType &&
                            priceInfo.bestDeal.finalPrice < priceInfo.currentDeal.finalPrice
                        "
                    >
                        <div class="price-info-box__better-option-header">
                            <feather-icon icon="ZapIcon" size="14" />
                            <strong>Daha Avantajlı Seçenek!</strong>
                        </div>
                        <div class="price-info-box__better-option-body">
                            {{ priceInfo.bestDeal.label }} ile <strong class="text-success">%{{ priceInfo.bestDeal.rate }}</strong> iskonto →
                            <strong>{{ priceInfo.bestDeal.finalPrice.toFixed(2) }} lt/TL</strong>
                            <span class="text-success"
                                >({{ (priceInfo.currentDeal.finalPrice - priceInfo.bestDeal.finalPrice).toFixed(2) }} TL tasarruf)</span
                            >
                        </div>
                    </div>

                    <!-- Optimal Seçim Mesajı -->
                    <div
                        class="price-info-box__optimal"
                        v-else-if="
                            priceInfo.bestDeal &&
                            priceInfo.currentDeal &&
                            priceInfo.bestDeal.paymentType === value.PaymentType &&
                            priceInfo.currentDeal.rate > 0
                        "
                    >
                        <feather-icon icon="CheckCircleIcon" size="14" />
                        <span>En avantajlı ödeme yöntemi seçili!</span>
                    </div>

                    <!-- İskonto Yok Uyarısı -->
                    <div
                        class="price-info-box__no-discount"
                        v-if="!priceInfo.bestDeal && priceInfo.currentDeal && !priceInfo.currentDeal.rate && priceInfo.status === 'warning'"
                    >
                        <feather-icon icon="InfoIcon" size="14" />
                        <span>Bu tedarikçi/tarih için tanımlı iskonto bulunamadı.</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Toplam Tutar [TL]</label>
            <input class="form-control" :value="calculatedTotalAmount" disabled />
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Taşıma Maliyeti</label>
            <VCurrencyInput :value="value.TransportAmount" @update-value="value.TransportAmount = $event" :disabled="isReadOnly" />
        </div>
        <div class="col-md-6 mb-1">
            <label class="form-label">Vade [Gün]</label>
            <b-form-input type="number" v-model="value.Vade" :disabled="isReadOnly" />
        </div>

        <div class="col-md-6 mb-1">
            <label class="form-label">Şube</label>
            <v-select-list :options="branches" v-model="branch" placeholder="Şube" label="Name" :disabled="isReadOnly"></v-select-list>
        </div>
        <div class="col-12 mb-75" v-if="!isAdBlue">
            <label class="form-label">Sürücü</label>
            <v-select-list
                v-model="employee"
                :options="employees"
                label="FullName"
                v-on:search="searchEmployees"
                placeholder="Sürücü adı girin…"
                :loading="employeeLoading"
                :disabled="isReadOnly"
            ></v-select-list>

            <div v-if="employee && employee.IdentityNumber" class="mt-25 ml-50">
                <small class="text-muted">
                    <feather-icon icon="UserCheckIcon" size="12" />
                    TCKN: <strong>{{ employee.IdentityNumber }}</strong>
                </small>
            </div>
        </div>
        <div class="col-md-6 mb-1" v-if="!isAdBlue">
            <label class="form-label">Araç Plakası</label>
            <v-select-list :options="truckPlates" v-model="plate" placeholder="Plaka" label="PlateValue" :disabled="isReadOnly"></v-select-list>
        </div>
        <div class="col-md-6 mb-1" v-if="!isAdBlue">
            <label class="form-label">Treyler Plakası</label>
            <v-select-list
                :options="trailerPlates"
                v-model="trailerPlate"
                placeholder="Treyler Plakası"
                label="PlateValue"
                :disabled="isReadOnly"
            ></v-select-list>
        </div>
        <div v-if="plateSelectionIsInvalid" class="col-12">
            <div class="alert alert-danger p-50 text-center" role="alert">
                <FeatherIcon icon="AlertTriangleIcon" size="16" class="mr-50"></FeatherIcon>Araç ve treyler plakası aynı olamaz.
            </div>
        </div>
    </div>
</template>

<script>
import VehicleOperationsApi from "@/api/vehicle-operations";
import CompanyApi from "@/api/company";
import EmployeeOperationsApi from "@/api/employee-operations";
import { BFormRadioGroup, BFormInput, BBadge } from "bootstrap-vue";
import SystemDataApi from "@/api/system-data";
import FirmOperationsApi from "@/api/firm-operations";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import VCurrencyInput from "@/components/VCurrencyInput.vue";
import FuelStorageApi from "@/api/fuel-storage";

export default {
    components: {
        BFormRadioGroup,
        VCurrencyInput,
        BFormInput,
        BBadge,
    },
    props: {
        value: Object,
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        isSubOrder: {
            type: Boolean,
            default: false,
        },
        subOrderIndex: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            suppliers: [],
            truckPlates: [],
            trailerPlates: [],
            branches: [],
            employees: [],
            employeeLoading: false,
            fuelTypes: [],
            vadeOptions: [],
            creditCards: [],
            paymentTypes: [
                { id: 0, label: "Peşin" },
                { id: 1, label: "Kredi Kartı" },
                { id: 2, label: "Vadeli" },
                { id: 3, label: "DBS" },
            ],
            refineryPrices: [],
            supplierDiscounts: [],
            supplierAgreements: [],
            priceInfo: {
                step: 0,
                status: "idle",
                icon: "HelpCircleIcon",
                title: "Sipariş Bilgilerini Doldurun",
                message: "Fiyat hesaplaması için gerekli alanları seçin.",
                missingFields: [],
                alternatives: [],
                bestDeal: null,
                currentDeal: null,
                basePrice: null,
            },
        };
    },
    mounted() {
        this.generateVadeOptions();
        this.getSuppliers();
        this.getTruckPlates();
        this.getTrailerPlates();
        this.getBranches();
        this.getFuelTypes();
        this.getCreditCards();
        this.getPricingData();
        if (this.value.DriverEmployee) {
            this.searchEmployees(this.value.DriverEmployee);
        }
    },
    methods: {
        generateVadeOptions() {
            for (let i = 0; i <= 180; i += 15) {
                this.vadeOptions.push(i);
            }
        },
        getSuppliers() {
            FirmOperationsApi.ListByFirmRole("5").then((res) => {
                this.suppliers = res.data.Data;
            });
        },
        getTruckPlates() {
            VehicleOperationsApi.Plate.ListAll().then((response) => {
                this.truckPlates = response.data.Data || [];
            });
        },
        getTrailerPlates() {
            VehicleOperationsApi.Plate.ListTrailer().then((response) => {
                this.trailerPlates = response.data.Data;
            });
        },
        getBranches() {
            // Sadece yakıt deposu olan şubeler listelenir. (Depo bulunmayan şubelere sipariş girilememesi için)
            FuelStorageApi.FuelStorage.BranchesWithFuelStorage().then((res) => {
                this.branches = res.data.Data || [];
            });
        },
        getStatuses() {
            SystemDataApi.FuelOrderStatusList().then((res) => {
                this.statuses = res.data.Data;
            });
        },
        searchEmployees(search) {
            if (search) {
                this.employeeLoading = true;
                EmployeeOperationsApi.Employee.SearchActiveDriver(search)
                    .then((res) => {
                        this.employees = res.data.Data;
                        this.employeeLoading = false;
                    })
                    .catch((err) => {
                        this.employeeLoading = false;
                    });
            }
        },
        getFuelTypes() {
            SystemDataApi.FuelType(true).then((res) => {
                this.fuelTypes = res.data.Data;
            });
        },
        getCreditCards() {
            FuelStorageApi.FuelStorageCreditCardInformation.List().then((res) => {
                this.creditCards = res.data.Data;
            });
        },
        disableDatesBeforeOneWeekAgo(date) {
            const oneWeekAgo = new Date();

            oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
            oneWeekAgo.setHours(0, 0, 0, 0);

            return date < oneWeekAgo;
        },
        calculateCardMaturity() {
            if (this.value.PaymentType !== 1 || !this.value.FuelStorageCreditCardInformationId || !this.value.OrderDate) {
                return;
            }

            const card = this.creditCards.find((c) => c.Id === this.value.FuelStorageCreditCardInformationId);
            if (!card) return;

            const orderDate = new Date(this.value.OrderDate);
            const year = orderDate.getFullYear();
            const month = orderDate.getMonth();
            const day = orderDate.getDate();

            let closingDate = new Date(year, month, card.AccountClosingDay);
            let finalPaymentDate;

            if (orderDate <= closingDate) {
                finalPaymentDate = new Date(year, month, card.AccountLastPaymentDay);
            } else {
                finalPaymentDate = new Date(year, month + 1, card.AccountLastPaymentDay);
            }

            this.value.FuelStorageCreditCardLastPaymentDate = finalPaymentDate.toISOString();

            const diffTime = Math.abs(finalPaymentDate - orderDate);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            this.value.Vade = diffDays;
        },
        getPricingData() {
            Promise.all([
                FuelStorageApi.FuelStorageRefineryPrice.List(),
                FuelStorageApi.FuelStorageSupplierIskonto.List(),
                FuelStorageApi.FuelStorageSupplierAgreement.List(),
            ]).then(([refineryRes, discountRes, agreementRes]) => {
                this.refineryPrices = refineryRes.data.Data || [];
                this.supplierDiscounts = discountRes.data.Data || [];
                this.supplierAgreements = agreementRes.data.Data || [];
            });
        },

        // Mevcut sipariş bilgilerini göster (isReadOnly durumunda)
        showExistingPriceInfo() {
            if (!this.value.UnitPrice) {
                this.priceInfo = {
                    step: 5,
                    status: "warning",
                    icon: "AlertCircleIcon",
                    title: "Birim Fiyat Bilgisi Yok",
                    message: "Sipariş için birim fiyat tanımlanmamış.",
                    missingFields: [],
                    alternatives: [],
                    bestDeal: null,
                    currentDeal: null,
                    basePrice: null,
                };
                return;
            }

            // Mevcut iskonto oranını göster
            const hasDiscount = this.value.FuelStorageSupplierIskontoRate && this.value.FuelStorageSupplierIskontoRate > 0;

            this.priceInfo = {
                step: 5,
                status: hasDiscount ? "success" : "warning",
                icon: hasDiscount ? "CheckCircleIcon" : "AlertCircleIcon",
                title: hasDiscount ? "İskonto Uygulandı" : "İskonto Bulunamadı",
                message: "",
                missingFields: [],
                alternatives: [],
                bestDeal: null,
                currentDeal: {
                    label: hasDiscount ? `%${this.value.FuelStorageSupplierIskontoRate} İskonto` : "İskonto Yok",
                    rate: this.value.FuelStorageSupplierIskontoRate || 0,
                    finalPrice: this.value.UnitPrice,
                    hasDiscount: hasDiscount,
                },
                basePrice: null,
            };
        },

        calculatePriceAndInfo() {
            // isReadOnly durumunda fiyat hesaplaması yapma
            if (this.isReadOnly) {
                return;
            }

            const missingFields = [];

            if (!this.value.FuelTypeId) {
                missingFields.push({ field: "FuelTypeId", label: "Yakıt Tipi", icon: "DropletIcon" });
            }
            if (!this.value.OrderDate) {
                missingFields.push({ field: "OrderDate", label: "Sipariş Tarihi", icon: "CalendarIcon" });
            }
            if (!this.value.SupplierId) {
                missingFields.push({ field: "SupplierId", label: "Tedarikçi", icon: "TruckIcon" });
            }
            if (this.value.PaymentType === null || this.value.PaymentType === undefined) {
                missingFields.push({ field: "PaymentType", label: "Ödeme Yöntemi", icon: "CreditCardIcon" });
            }

            if (missingFields.length > 0) {
                const completedCount = 4 - missingFields.length;
                this.priceInfo = {
                    step: completedCount,
                    status: "pending",
                    icon: missingFields[0].icon,
                    title: `${missingFields[0].label} Seçin`,
                    message: `Fiyat hesaplaması için ${missingFields.length} alan kaldı.`,
                    missingFields: missingFields.map((f) => f.label),
                    alternatives: [],
                    bestDeal: null,
                    currentDeal: null,
                    basePrice: null,
                };
                return;
            }

            let orderDate;
            if (typeof this.value.OrderDate === "string" && this.value.OrderDate.includes(".")) {
                const parts = this.value.OrderDate.split(".");
                orderDate = new Date(parts[2], parts[1] - 1, parts[0]);
            } else {
                orderDate = new Date(this.value.OrderDate);
            }
            if (isNaN(orderDate.getTime())) return;

            if (this.isAdBlue) {
                this.calculateAdBluePrice(orderDate);
                return;
            }

            const validRefineryPrice = this.refineryPrices
                .filter((x) => new Date(x.StartDate) <= orderDate)
                .sort((a, b) => new Date(b.StartDate) - new Date(a.StartDate))[0];

            if (!validRefineryPrice) {
                this.priceInfo = {
                    step: 4,
                    status: "error",
                    icon: "AlertTriangleIcon",
                    title: "Rafineri Fiyatı Bulunamadı",
                    message: "Bu tarih için tanımlı rafineri fiyatı yok.",
                    missingFields: [],
                    alternatives: [],
                    bestDeal: null,
                    currentDeal: null,
                    basePrice: null,
                };
                return;
            }

            const basePrice = validRefineryPrice.PriceWithoutTax;
            const allDiscounts = this.supplierDiscounts.filter(
                (x) =>
                    x.SupplierId === this.value.SupplierId && new Date(x.StartDate) <= orderDate && (!x.EndDate || new Date(x.EndDate) >= orderDate),
            );

            const alternatives = this.paymentTypes.map((pt) => {
                const discount = allDiscounts.find((d) => d.PaymentType === pt.id);
                const rate = discount ? discount.Rate : 0;
                const finalPrice = basePrice - (basePrice * rate) / 100;
                return {
                    paymentType: pt.id,
                    label: pt.label,
                    rate: rate,
                    finalPrice: parseFloat(finalPrice.toFixed(2)),
                    discountId: discount ? discount.Id : null,
                    hasDiscount: rate > 0,
                };
            });

            const discountedAlternatives = alternatives.filter((a) => a.hasDiscount);
            const bestDeal = discountedAlternatives.length > 0 ? [...discountedAlternatives].sort((a, b) => a.finalPrice - b.finalPrice)[0] : null;
            const currentDeal = alternatives.find((a) => a.paymentType === this.value.PaymentType);

            if (currentDeal) {
                this.value.UnitPrice = currentDeal.finalPrice;
                this.value.FuelStorageSupplierIskontoId = currentDeal.discountId;
                this.value.FuelStorageSupplierIskontoRate = currentDeal.rate;
            }

            let status = "success";
            let icon = "CheckCircleIcon";
            let title = "Fiyat Hesaplandı";

            if (!currentDeal.hasDiscount) {
                status = "warning";
                icon = "AlertCircleIcon";
                title = "İskonto Bulunamadı";
            } else if (bestDeal && bestDeal.paymentType !== this.value.PaymentType && bestDeal.rate > currentDeal.rate) {
                status = "info";
                icon = "ZapIcon";
                title = "Daha İyi Seçenek Var!";
            }

            this.priceInfo = {
                step: 5,
                status: status,
                icon: icon,
                title: title,
                message: "",
                missingFields: [],
                alternatives: alternatives.filter((a) => a.hasDiscount),
                bestDeal: bestDeal,
                currentDeal: currentDeal,
                basePrice: basePrice,
            };
        },

        calculateAdBluePrice(orderDate) {
            const agreement = this.supplierAgreements.find(
                (x) => x.SupplierId === this.value.SupplierId && x.IsActive && new Date(x.StartDate) <= orderDate && new Date(x.EndDate) >= orderDate,
            );

            if (agreement) {
                this.value.UnitPrice = agreement.UnitPrice;
                this.value.FuelStorageSupplierAgreementId = agreement.Id;
                this.priceInfo = {
                    step: 5,
                    status: "success",
                    icon: "FileTextIcon",
                    title: "Sözleşme Fiyatı Uygulandı",
                    message: "",
                    missingFields: [],
                    alternatives: [],
                    bestDeal: null,
                    currentDeal: {
                        label: `Sözleşme: ${agreement.AgreementNo}`,
                        finalPrice: agreement.UnitPrice,
                        rate: 0,
                    },
                    basePrice: null,
                };
            } else {
                this.priceInfo = {
                    step: 5,
                    status: "warning",
                    icon: "AlertCircleIcon",
                    title: "Sözleşme Bulunamadı",
                    subtitle: "Bu tedarikçi/tarih için aktif sözleşme yok.",
                    missingFields: [],
                    alternatives: [],
                    bestDeal: null,
                    currentDeal: null,
                    basePrice: null,
                };
            }
        },
    },
    computed: {
        supplier: {
            get: function () {
                return this.suppliers.find((b) => b.Id == this.value.SupplierId);
            },
            set: function (value) {
                this.value.SupplierId = value?.Id || null;
            },
        },
        plate: {
            get: function () {
                return this.truckPlates.find((b) => b.Id == this.value.VehiclePlateId);
            },
            set: function (value) {
                this.value.VehiclePlateId = value?.Id || null;
            },
        },
        trailerPlate: {
            get: function () {
                return this.trailerPlates.find((b) => b.Id == this.value.TrailerPlateId);
            },
            set: function (value) {
                this.value.TrailerPlateId = value?.Id || null;
            },
        },
        isAdBlue() {
            const selected = this.fuelTypes.find((f) => f.Id == this.value.FuelTypeId);
            return selected?.VisibleName === "ADBLUE";
        },
        fuelType: {
            get: function () {
                return this.fuelTypes.find((f) => f.Id == this.value.FuelTypeId);
            },
            set: function (value) {
                this.value.FuelTypeId = value?.Id || null;
                this.value.FuelTypeName = value?.VisibleName || null;
                if (value?.VisibleName === "ADBLUE") {
                    this.value.DriverEmployeeId = null;
                    this.value.DriverEmployee = null;
                    this.value.VehiclePlateId = null;
                    this.value.TrailerPlateId = null;
                }
            },
        },
        branch: {
            get() {
                return this.branches.find((b) => b.Id === this.value.FuelOrderBranchId);
            },
            set(value) {
                this.value.FuelOrderBranchId = value?.Id || null;
            },
        },
        employee: {
            get: function () {
                return this.employees.find((s) => s.Id == this.value.DriverEmployeeId);
            },
            set: function (value) {
                this.value.DriverEmployeeId = value?.Id || null;
            },
        },
        plateSelectionIsInvalid() {
            return this.value.VehiclePlateId && this.value.TrailerPlateId && this.value.VehiclePlateId === this.value.TrailerPlateId;
        },
        statusVariantClass() {
            const variantMap = {
                0: "alert-info",
                1: "alert-warning",
                2: "alert-secondary",
                3: "alert-success",
                4: "alert-danger",
            };
            return variantMap[this.value.OrderStatus] || "alert-info";
        },
        calculatedTotalAmount() {
            if (this.value.OrderQuantity && this.value.UnitPrice) {
                return (this.value.OrderQuantity * this.value.UnitPrice).toLocaleString("tr-TR", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                });
            }
            return "0,00";
        },
    },
    watch: {
        plateSelectionIsInvalid(isInvalid) {
            this.$emit("validation-changed", isInvalid);
        },
        "value.Id": {
            immediate: true,
            handler(newVal) {
                if (newVal || this.isReadOnly) {
                    this.showExistingPriceInfo();
                } else {
                    this.priceInfo = {
                        step: 0,
                        status: "idle",
                        icon: "HelpCircleIcon",
                        title: "Sipariş Bilgilerini Doldurun",
                        message: "Fiyat hesaplaması için gerekli alanları seçin.",
                        missingFields: [],
                        alternatives: [],
                        bestDeal: null,
                        currentDeal: null,
                        basePrice: null,
                    };
                }
            },
        },
        "value.FuelStorageCreditCardInformationId": function () {
            this.calculateCardMaturity();
        },
        "value.OrderDate": function () {
            this.calculateCardMaturity();
            this.calculatePriceAndInfo();
        },
        "value.PaymentType": function (newVal) {
            if (newVal === 1) {
                this.calculateCardMaturity();
            } else {
                this.value.Vade = 0;
            }
            this.calculatePriceAndInfo();
        },
        "value.FuelTypeId": function () {
            this.calculatePriceAndInfo();
        },
        "value.SupplierId": function () {
            this.calculatePriceAndInfo();
        },
    },
};
</script>
<style scoped>
.price-info-box {
    border-radius: 8px;
    padding: 14px 16px;
    border: 1px solid rgba(108, 117, 125, 0.3);
    background: rgba(108, 117, 125, 0.06);
}

.price-info-box--success {
    border-color: rgba(40, 199, 111, 0.4);
    background: rgba(40, 199, 111, 0.08);
}

.price-info-box--warning {
    border-color: rgba(255, 159, 67, 0.4);
    background: rgba(255, 159, 67, 0.08);
}

.price-info-box--error {
    border-color: rgba(234, 84, 85, 0.4);
    background: rgba(234, 84, 85, 0.08);
}

.price-info-box--pending {
    border-color: rgba(13, 110, 253, 0.4);
    background: rgba(13, 110, 253, 0.08);
}

.price-info-box--info {
    border-color: rgba(0, 207, 232, 0.4);
    background: rgba(0, 207, 232, 0.08);
}

.price-info-box__header {
    display: flex;
    align-items: center;
    gap: 12px;
}

.price-info-box__icon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: rgba(108, 117, 125, 0.15);
    color: #6c757d;
}

.price-info-box--pending .price-info-box__icon {
    background: rgba(13, 110, 253, 0.15);
    color: #0d6efd;
}

.price-info-box--success .price-info-box__icon {
    background: rgba(40, 199, 111, 0.15);
    color: #28c76f;
}

.price-info-box--warning .price-info-box__icon {
    background: rgba(255, 159, 67, 0.15);
    color: #ff9f43;
}

.price-info-box--error .price-info-box__icon {
    background: rgba(234, 84, 85, 0.15);
    color: #ea5455;
}

.price-info-box--info .price-info-box__icon {
    background: rgba(0, 207, 232, 0.15);
    color: #00cfe8;
}

.price-info-box__title-wrapper {
    flex: 1;
    min-width: 0;
}

.price-info-box__title {
    font-weight: 600;
    font-size: 0.95rem;
    color: inherit;
}

.price-info-box__subtitle {
    font-size: 0.8rem;
    opacity: 0.7;
    margin-top: 2px;
}

.price-info-box__dots {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
}

.price-info-box__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: rgba(128, 128, 128, 0.25);
    transition: all 0.2s ease;
}

.price-info-box__dot--done {
    background: #28c76f;
}

.price-info-box__dot--current {
    background: #0d6efd;
    animation: dotPulse 1.5s ease-in-out infinite;
}

@keyframes dotPulse {
    0%,
    100% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.25);
        opacity: 0.7;
    }
}

.price-info-box__body {
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px solid rgba(128, 128, 128, 0.15);
}

.price-info-box__next-step {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
}

.price-info-box__result {
    background: rgba(128, 128, 128, 0.08);
    border: 1px solid rgba(128, 128, 128, 0.12);
    border-radius: 6px;
    padding: 12px;
}

.price-info-box__result-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
    font-size: 0.9rem;
}

.price-info-box__result-row--total {
    margin-top: 6px;
    padding-top: 10px;
    border-top: 1px solid rgba(128, 128, 128, 0.12);
    font-size: 1rem;
}

.price-info-box__better-option {
    margin-top: 12px;
    padding: 12px;
    background: rgba(255, 159, 67, 0.1);
    border: 1px dashed #ff9f43;
    border-radius: 6px;
}

.price-info-box__better-option-header {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #ff9f43;
    margin-bottom: 6px;
}

.price-info-box__better-option-body {
    font-size: 0.875rem;
}

.price-info-box__optimal,
.price-info-box__no-discount {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
    font-size: 0.875rem;
}

.price-info-box__optimal {
    color: #28c76f;
}

.price-info-box__no-discount {
    color: #ff9f43;
}

.price-info-box__price-compare {
    display: flex;
    align-items: center;
    gap: 8px;
}

.price-info-box__old-price {
    text-decoration: line-through;
    opacity: 0.5;
    font-size: 0.85rem;
}
</style>
